import analytics from "web/script/analytics/analytics";
import globals from "web/script/modules/globals";
import url from "web/script/utils/url";
import { getProductPageRegex, getSignupPageRegex } from "web/script/routing/routes";

let seenPath;

const VALID_COMPONENTS = ["default-layout", "product-feed-layout", "sale-hub-layout"];

/**
 * Handle updating a product feed if there is one.
 */
function updateProductFeedLayout(path, queryParams, layout) {
    layout.updateOptions({
        url: `${path}?${url.toQueryString(queryParams)}`,
    });
}

export default {
    enter(path, queryParams, parent) {
        let component;
        for (let index in VALID_COMPONENTS) {
            component = parent.findComponent(VALID_COMPONENTS[index]);
            if (component) {
                break;
            }
        }

        if (!component) {
            console.warn("Cannot create new default layouts. The page will now be reloaded!");
            globals.window.location.reload();
        }

        // remember this path as we can only ever allow the first one through (the server rendered page)
        seenPath = path;

        return component;
    },

    update(path, queryParams, layout) {
        if (layout.name === "product-feed-layout") {
            updateProductFeedLayout(path, queryParams, layout);
            return;
        }

        // if this path is different to the one we have already seen then we need to reload the page
        if (seenPath && seenPath !== path) {
            console.warn(
                "Updating the catch all route and the path has changed. The page will now be reloaded!"
            );
            globals.window.location.reload();
            return;
        }

        // it's the same path it must mean that we are coming back to this route after showing a sub-route e.g. a product overlay
        analytics.pageView();
    },

    exit(nextPath, queryParams, component) {
        // Don't destroy the component the next page is a product or signup overlay
        if (nextPath.match(getProductPageRegex()) || nextPath.match(getSignupPageRegex())) {
            return;
        }

        component.destroy();
    },
};
